<div class="layout-column">

  <label *ngIf="placeholder">{{ placeholder | translate}}</label>

  <ng-select [items]="options"
             [ngModel]="selectedValue"
             [required]="required"
             [bindValue]="bindValue"
             [bindLabel]="bindLabel"
             [placeholder]="placeholder"
             [appendTo]="appendTo"
             [searchFn]="customSearch"
             [class.invalid]="control?.invalid && control?.touched"
             (ngModelChange)="onSelectionChange($event)">
    <!--  <ng-template ng-option-tmp let-item="item" let-selected="selected">-->
    <!--    <span class="br-body-2 font-weight-400 secondary-100">{{item}}</span>-->
    <!--  </ng-template>-->

<!--    <ng-content></ng-content>-->

    <!-- Pass the captured templates to ng-select -->
    <ng-template *ngIf="labelTemplate" ng-label-tmp let-selected>
      <ng-container *ngTemplateOutlet="labelTemplate; context: { $implicit: selected }"></ng-container>
    </ng-template>

    <ng-template *ngIf="optionTemplate" ng-option-tmp let-item="item">
      <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: item }"></ng-container>
    </ng-template>


  </ng-select>

  <p *ngIf="control?.invalid && control?.touched" class="invalid-error-message">
    This field is required!
  </p>

</div>
